
import React from 'react'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  title: {
    fontSize: 14,
    marginBottom: '5px'
  },
  card: {
    marginBottom: '10px',
    backgroundColor: '#eeeeee'
  }
})

export default function NewProductDialogCard (props) {
  const classes = useStyles()

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Typography className={classes.title} color="primary">
          {props.title}
        </Typography>
        {props.children}
      </CardContent>
    </Card>
  )
}

NewProductDialogCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}
